<div class="row mt-3 mb-3">
  <div class="col-12">
    <button (click)="adicionar()" #btnAdicionar class="btn btn-sm btn-outline-primary">
      <img src="assets/img/global/plus.png" alt="adicionar" title="Adicionar" height="16" width="16">
      Adicionar
    </button>
  </div>
</div>
<table class="table table-eddy">
  <thead>
    <tr>
      <th style="width: 45%" scope="col">Código de Barra</th>
      <th style="width: 40%" scope="col">Marca</th>
      <th style="width: 10%" scope="col"></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of lista; let idx = index">
      <td *ngIf="!item.editavel" style="width: 45%">{{item.codigo_barra}}</td>
      <td *ngIf="!item.editavel" style="width: 40%">{{item.marca}}</td>
      <td *ngIf="item.editavel" style="width: 45%">
        <input id="codigobarra" [(ngModel)]="itemAtual.codigo_barra" [ngModelOptions]="{standalone: true}" type="text"
          class="form-control">
      </td>
      <td *ngIf="item.editavel" style="width: 40%">
        <input id="marca" [(ngModel)]="itemAtual.marca" [ngModelOptions]="{standalone: true}" type="text"
          class="form-control ">
      </td>
      <td class="text-right" style="width: 10%">
        <button *ngIf="item.editavel" (click)="salvar(item)" class="btn btn-sm btn-outline-secondary mr-2">
          <img src="assets/img/global/tick.png" alt="salvar" height="16" width="16">
        </button>
        <button *ngIf="item.editavel" (click)="cancelar(item)" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/cross.png" alt="editar" height="16" width="16">
        </button>
        <button *ngIf="!item.editavel" (click)="editar(item)" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
        </button>
        <button *ngIf="!item.editavel" (click)="remover(item)" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
        </button>
      </td>
    </tr>
  </tbody>
</table>